/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForAiGateway extends models.GovernanceConfigurationBaseForOperations {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForAiGateway.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForAiGateway>): GovernanceConfigurationBaseForAiGateway {
        let obj = Object.assign(new GovernanceConfigurationBaseForAiGateway(), model);
        GovernanceConfigurationBaseForAiGateway.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForAiGateway>): GovernanceConfigurationBaseForAiGateway {
        if (!model) return null;
        return GovernanceConfigurationBaseForAiGateway.newInstance(<GovernanceConfigurationBaseForAiGateway> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForAiGateway) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForAiGateway.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForAiGateway): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForAiGateway.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
